import { Styles, css, cx } from '@flipster/styled-system/css';
import { square } from '@flipster/styled-system/patterns';
import { textTrigger, type TextTriggerVariantProps } from '@flipster/styled-system/recipes';

import InformationCircleIcon from '../../icon/generated/InformationCircleIcon';
import { Trigger } from './tooltip';

interface IconTriggerProps {
  label: React.ReactNode;
  css?: Styles;
}

const IconTrigger = ({ label, css: cssProps }: IconTriggerProps) => {
  return (
    <Trigger asChild>
      <button
        className={css(
          { display: 'inline-flex', alignItems: 'center', color: 'content.default.level-2', w: 'max-content' },
          cssProps,
        )}
      >
        {label}
        <div className={square({ size: 24, color: 'content.default.level-1' })}>
          <InformationCircleIcon size={16} />
        </div>
      </button>
    </Trigger>
  );
};

IconTrigger.displayName = 'Tooltip.IconTrigger';

interface TextTriggerProps {
  label: React.ReactNode;
  color?: TextTriggerVariantProps['color'];
  css?: Styles;
}

const TextTrigger = ({ label, color, css: cssProps }: TextTriggerProps) => {
  const classes = textTrigger({ color });
  return (
    <Trigger asChild>
      <button className={cx(classes.root, css(cssProps))}>
        <span className={classes.label}>{label}</span>
      </button>
    </Trigger>
  );
};

TextTrigger.displayName = 'Tooltip.TextTrigger';

export { IconTrigger, TextTrigger };
